import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import {
  AreaDataModel,
  
  IAreaRequest,
  CategoryDataModel,
  IDistrictData,
  
} from "../models";
import { MockAxiosResponse } from "utils/commonModels";

export interface HomepageState {
  areaList: AreaDataModel[];
  districtList: IDistrictData[];
  keywordList: string[];
  foodGenreList: CategoryDataModel[];
  scenarioList: CategoryDataModel[];
  conditionList: CategoryDataModel[];
  isLoading: boolean;
  gerneLoading: boolean;
  scenarioLoading: boolean;
  conditionLoading: boolean;
  errorMsg: string;
}

const initialState: HomepageState = {
  areaList: [],
  districtList: [],
  keywordList: [],
  foodGenreList: [],
  scenarioList: [],
  conditionList: [],
  isLoading: false,
  gerneLoading: false,
  scenarioLoading: false,
  conditionLoading: false,
  errorMsg: "",
};

const homepageSlice = createSlice({
  name: "homepage",
  initialState: initialState,
  reducers: {
    // Produc slide
    getDataFailed(state: HomepageState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.errorMsg = action.payload;
    },
    // Area
    getAreas(state: HomepageState, action: PayloadAction<number>) {
      state.isLoading = true;
    },
    getAreasSuccess(
      state: HomepageState,
      action: PayloadAction<AreaDataModel[]>
    ) {
      state.isLoading = false;
      state.areaList = action.payload;
    },
    // District
    getDistricts(state: HomepageState, action: PayloadAction<number>) {
      state.isLoading = true;
    },
    getDistrictsSuccess(state: HomepageState, action: PayloadAction<IDistrictData[]>) {
      state.isLoading = false;
      state.districtList = action.payload;
    },
    // Keyword
    getKeywords(state: HomepageState, action: PayloadAction<string>) {
      state.isLoading = true;
    },
    getKeywordsSuccess(
      state: HomepageState,
      action: PayloadAction<MockAxiosResponse<string[]>>
    ) {
      state.isLoading = false;
      state.keywordList = action.payload.data;
    },
    // Food genre
    getFoodGenres(state: HomepageState, action: PayloadAction<number>) {
      state.gerneLoading = true;
    },
    getFoodGenresSuccess(
      state: HomepageState,
      action: PayloadAction<CategoryDataModel[]>
    ) {
      state.gerneLoading = false;
      state.foodGenreList = action.payload;
    },
    getFoodGenresFail(
      state: HomepageState,
      action: PayloadAction<string>
    ) {
      state.gerneLoading = false;
      state.errorMsg = action.payload;
    },
    // Screnario
    getScrenario(state: HomepageState, action: PayloadAction<number>) {
      state.scenarioLoading = true;
    },
    getScrenarioSuccess(
      state: HomepageState,
      action: PayloadAction<CategoryDataModel[]>
    ) {
      state.scenarioLoading = false;
      state.scenarioList = action.payload;
    },
    getScenarioFail(
      state: HomepageState,
      action: PayloadAction<string>
    ) {
      state.scenarioLoading = false;
      state.errorMsg = action.payload;
    },
    // Condition
    getConditions(state: HomepageState, action: PayloadAction<number>) {
      state.conditionLoading = true;
    },
    getConditionsSuccess(
      state: HomepageState,
      action: PayloadAction<CategoryDataModel[]>
    ) {
      state.conditionLoading = false;
      state.conditionList = action.payload;
    },
    getConditionFail(
      state: HomepageState,
      action: PayloadAction<string>
    ) {
      state.conditionLoading = false;
      state.errorMsg = action.payload;
    },
  },
});

export const homepageActions = homepageSlice.actions;

export const selectLoading = (state: RootState) => state.homepage.isLoading;
export const selectGenresLoading = (state: RootState) => state.homepage.gerneLoading;
export const selectScenariosLoading = (state: RootState) => state.homepage.scenarioLoading;
export const selectConditionsLoading = (state: RootState) => state.homepage.conditionLoading;

export const selectAreas = (state: RootState) => state.homepage.areaList;
export const selectDistricts = (state: RootState) =>
  state.homepage.districtList;
export const selectKeywords = (state: RootState) => state.homepage.keywordList;
export const selectGenres = (state: RootState) => state.homepage.foodGenreList;
export const selectScenarios = (state: RootState) =>
  state.homepage.scenarioList;
export const selectConditions = (state: RootState) =>
  state.homepage.conditionList;

const homepageReducer = homepageSlice.reducer;
export default homepageReducer;
